import { Theme } from "@mui/material/styles";
import { HMO } from "constants/hmo";
import { detectHmo } from "utils/hmoDetection";

interface Styles {
  [key: string]: any;
}

const isLeumit = detectHmo() === HMO.LEUMIT;

export const styles = (theme: Theme): Styles => ({
  timerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: theme.width.full,
    height: theme.spacing.spacing59,
    padding: `${theme.spacing.spacing6} ${theme.spacing.spacing10} 0 ${theme.spacing.spacing10}`,
    backgroundColor: isLeumit
      ? (theme.palette.background as any).soft
      : (theme.palette.background as any).primary,
    borderRadius: theme.borders.borderRadius.xl,
  },
  timerText2: {
    fontSize: theme.typography.size.xs,
    textAlign: "center",
    lineHight: "18px",
  },
  timer: {
    fontSize: theme.typography.size.size25,
    lineHeight: "147%",
    ...(isLeumit && {
      fontWeight: 500,
    }),
  },
});
